import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result, } from "../../../../interfaces";
import { Find, FindById } from "../../../capacitiesTypes";
import { Adapter } from "../../../../shared/adapter";
import { CapacitiesTypesAdapter } from "../../../../adapter/capacitiesTypes-adapter";

export const FETCH_DATA_CAPACITIES_TYPES_REQUEST = 'FETCH_DATA_CAPACITIES_TYPES_REQUEST';
export const FETCH_DATA_CAPACITIES_TYPES_SUCCESS = 'FETCH_DATA_CAPACITIES_TYPES_SUCCESS';
export const FETCH_DATA_CAPACITIES_TYPES_FAILURE = 'FETCH_DATA_CAPACITIES_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataCapacitiesTypesRequest = () => {
    return {
        type: FETCH_DATA_CAPACITIES_TYPES_REQUEST,
    };
};

const fetchDataCapacitiesTypesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_CAPACITIES_TYPES_SUCCESS,
        payload: data
    };
};

const fetchDataCapacitiesTypesFailure = (error: any) => {
    return {
        type: FETCH_DATA_CAPACITIES_TYPES_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataCapacitiesTypesRequest());
        try {
            const response = await Find('capacitiesTypes', query, page, pageSize);
            dispatch(fetchDataCapacitiesTypesSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new CapacitiesTypesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataCapacitiesTypesFailure(error.message));
        }
    };
};

export const findActorById = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataCapacitiesTypesRequest());
        try {
            const response = await FindById(id);
            dispatch(fetchDataCapacitiesTypesSuccess(
                { 
                    values : Adapter.from([response]).to((value) => new CapacitiesTypesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataCapacitiesTypesFailure(error.message));
        }
    };
};
